import { render, staticRenderFns } from "./LoanTable.vue?vue&type=template&id=30989986&scoped=true&"
import script from "./LoanTable.vue?vue&type=script&lang=js&"
export * from "./LoanTable.vue?vue&type=script&lang=js&"
import style0 from "./LoanTable.vue?vue&type=style&index=0&id=30989986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30989986",
  null
  
)

export default component.exports